const clearLocalStorage = (): void => {
    window.localStorage.clear();
};

export default clearLocalStorage;
